import { defineStore } from "pinia";
import { Ref, ref, onMounted, computed, ComputedRef, watch } from "vue";
import { useWoodvisionAvailabilityStore } from "../stores/WoodvisionAvailabilityStore";
import { CheckoutSteps, CheckoutStoreEventBus, useCheckoutStore } from "../../../base/ts/stores/CheckoutStore";

export const useCustomizationCheckoutStore = defineStore("customizationCheckout", () => {
    // Data
    const isUnAvailable: Ref<boolean> = ref(false);
    // Pinia stores
    const woodvisionAvailabilityStore = useWoodvisionAvailabilityStore();
    const checkoutStore = useCheckoutStore();

    init();

    function init() {
        // Fetch the Basket's availability on checkout pages, excluding the Basket page (handled by Basket.vue).
        if (
            checkoutStore.currentStep !== null &&
            checkoutStore.currentStep !== CheckoutSteps.BASKET &&
            checkoutStore.currentStep !== CheckoutSteps.SUCCESS
        ) {
            woodvisionAvailabilityStore.getWoodvisionBasketAvailability(true).finally(() => {
                isUnAvailable.value =
                    woodvisionAvailabilityStore.basketAvailability &&
                    !woodvisionAvailabilityStore.basketAvailability.orderLevelAvailability;
            });
        }
    }

    CheckoutStoreEventBus.on("afterNextStep", () => {
        init();
    });

    return {
        isUnAvailable,
    };
});
